import React from 'react';

const Attractions = () => {
  const attractions = [
    
    {
      name: 'Peace Pagoda',
      description: 'A beautiful Buddhist stupa located on a hilltop.',
      distance: '6.9 km',
      image: `${process.env.PUBLIC_URL}/assets/peace_pagoda.png`
    },
    {
      name: 'Tal Barahi Temple',
      description: 'A temple located on an island in Phewa Lake.',
      distance: '1.6 km',
      image: `${process.env.PUBLIC_URL}/assets/tal_barahi.png`
    },
    {
      name: 'Sarangkot',
      description: 'Famous for sunrise and mountain views.',
      distance: '10 km',
      image: `${process.env.PUBLIC_URL}/assets/sarangkot.png`
    },
    {
      name: 'Pumdikot Shiva Statue',
      description: 'A statue of Lord Shiva located in Pumdikot.',
      distance: '10.8 km',
      image: `${process.env.PUBLIC_URL}/assets/pum_shiva.png`
    },
    {
      name: "Davi's Fall",
      description: 'A beautiful waterfall and popular tourist spot.',
      distance: '3.4 km',
      image: `${process.env.PUBLIC_URL}/assets/davidfall.jpg`
    }
  ];

  return (
    <div className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-serif font-bold text-primary text-center mb-12">Attractions in Pokhara</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {attractions.map((attraction, index) => (
            <div key={index} className="bg-highlight rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <img src={attraction.image} alt={attraction.name} className="w-full h-48 object-cover hover:scale-105 transition-transform duration-300" />
              <div className="p-6">
                <h3 className="text-xl font-serif font-bold text-primary mb-2">{attraction.name}</h3>
                <p className="text-secondary mb-4 leading-relaxed">{attraction.description}</p>
                <p className="text-sm text-accent font-semibold">Distance: {attraction.distance}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Attractions;